import * as Yup from "yup";
import { FIELD_NAMES } from "../../../constants/commonConstants";

export const applyBankStepSchema = Yup.object({
  [FIELD_NAMES.BANK_STATEMENTS_ID]: Yup.string()
});